import { ChangeDetectionStrategy, Component } from '@angular/core';
import { HeaderService } from '../../../services';

/**
 * S03-P030_シートマップ（参照）画面用ヘッダー
 */
@Component({
  selector: 'asw-informative-seatmap-header',
  templateUrl: './informative-seatmap-header.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InformativeSeatmapHeaderComponent {
  constructor(public headerService: HeaderService) {}
}
